import React from "react";
import styles from "./PhoneInputComponent.module.scss";

interface PhoneInputProps {
  label?: string;
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  error?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  selectedCode?: string | number;
  onCodeChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PhoneInputComponent: React.FC<PhoneInputProps> = ({
  label,
  id,
  name,
  placeholder = "00 000 00 00",
  value,
  onChange,
  onBlur,
  error,
}) => {
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, "");

    // Azərbaycan nömrəsi üçün limit 9 rəqəmdir (məs: 50 777 77 77)
    if (numericValue.length <= 9) {
      e.target.value = numericValue;
      onChange(e);
    }
  };

  return (
    <div className={styles.phoneInput}>
      {label && (
        <label className={styles.labelInput} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={styles.phoneInputGroup}>
        <div
          className={styles.phoneCodeFixed}
          aria-label="Ölkə kodu: +994"
          tabIndex={-1}
        >
          +994
        </div>
        <input
          type="tel"
          style={{ color: "#000" }}
          id={id}
          name={name}
          maxLength={9}
          placeholder={placeholder}
          className={styles.liveSupportFormInput}
          value={value}
          onChange={handlePhoneChange}
          onBlur={onBlur}
          aria-label={label || "Telefon nömrəsi"}
        />
      </div>
      {error ? (
        <p className={`${styles.errorMessage} ${styles.visible}`}>{error}</p>
      ) : (
        <p className={styles.hidden}>empty</p>
      )}
    </div>
  );
};

export default PhoneInputComponent;
